// ExpandableCell.tsx
import React, { useState } from 'react';
import { Link, SpaceBetween } from '@amzn/awsui-components-console';

interface ExpandableCellProps {
  items: string[] | undefined;
  maxVisible?: number;
}

const ExpandableCell: React.FC<ExpandableCellProps> = ({
  items,
  maxVisible = 3,
}) => {
  const [expanded, setExpanded] = useState(false);

  if (!items || items.length === 0) return <>—</>;
  if (items.length <= maxVisible) return <>{items.join(', ')}</>;

  const displayed = expanded ? items : items.slice(0, maxVisible);
  const remaining = items.length - maxVisible;

  return (
    <SpaceBetween size="xxs" direction="horizontal">
      <span>{displayed.join(', ')}</span>
      <Link
        onFollow={(e) => {
          e.preventDefault();
          setExpanded(!expanded);
        }}
        variant="info"
      >
        {expanded ? 'Show less' : `+${remaining} more`}
      </Link>
    </SpaceBetween>
  );
};

export default ExpandableCell;
